























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { storeReferensi } from "@/store/modules/referensi";

interface AutocompleteOptions {
  outlined: true;
  label: "";
}

@Component({
  components: {},
})
export default class KelasAutoComplete extends Vue {
  @Prop() setKelas!: object;

  @Prop({
    default: () => {
      return {
        outlined: true,
        label: null,
      };
    },
  })
  opt: AutocompleteOptions;

  get listKelas() {
    return storeReferensi.kelas;
  }

  // listKelas = [
  //   {
  //     id: "1",
  //     nama: "ISOLASI",
  //   },
  //   {
  //     id: "2",
  //     nama: "VIP A",
  //   },
  //   {
  //     id: "3",
  //     nama: "VIP B",
  //   },
  //   {
  //     id: "4",
  //     nama: "1",
  //   },
  //   {
  //     id: "5",
  //     nama: "2",
  //   },
  //   {
  //     id: "6",
  //     nama: "3",
  //   },
  // ];

  kelas = {};

  list = [];

  searchKelas = null;

  loading = false;

  @Watch("setKelas")
  valKelas(val) {
    this.$emit("kelas", val);
  }
}
